/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import React from 'react';
import AppButton from "../button/AppButton";
import {FaPencilAlt, FaShoppingBag} from "react-icons/fa";
import {CiCircleCheck} from "react-icons/ci";
import {appAmbassadorPageURL, appContactPageURL} from '../../utils/AppConfig';
import AppStatic from "../../utils/AppStatic";
import Image from 'next/image';
import AmbassadorImage from '@/assets/images/ambassador/weddify-ambassador.webp';

const AppAmbassador = () => {
    return (
        <div className="relative text-[#EBE6DE]">
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-2 items-center">
                <div>
                    <h3 className="text-4xl font-bold mb-4 md:text-6xl">{AppStatic.appAmbassadorHeading.ro.translation}</h3>
                    <p className="mb-6 text-base font-thin tracking-wider">{AppStatic.appAmbassadorFirstHook.ro.translation}</p>
                    <p className="text-2xl font-bold mb-6">
                        {AppStatic.appAmbassadorPropositionPartOne.ro.translation}
                        <span className="font-bold text-3xl">{AppStatic.appAmbassadorPropositionPartTwo.ro.translation}</span>
                        {AppStatic.appAmbassadorPropositionPartThree.ro.translation}
                    </p>
                    <p className="text-base flex items-center gap-2">
                        <CiCircleCheck className="text-3xl"/>
                        {AppStatic.appAmbassadorFirstFeature.ro.translation}
                    </p>
                    <p className="text-base flex items-center gap-2">
                        <CiCircleCheck className="text-3xl"/>
                        {AppStatic.appAmbassadorSecondFeature.ro.translation}
                    </p>
                    <p className="text-base flex items-center gap-2">
                        <CiCircleCheck className="text-3xl"/>
                        {AppStatic.appAmbassadorThirdFeature.ro.translation}
                    </p>
                </div>
                <div className="relative">
					<Image alt="Weddify by Diaphan" className="mx-auto object-cover"
						   src={AmbassadorImage}/>
                    <div className="mb-10 mt-10 justify-center flex flex-wrap gap-2">
                        <AppButton data={{
                            action: "link",
                            link: appAmbassadorPageURL,
                            name: AppStatic.mainLearnMore.ro.translation,
                            icon: <FaShoppingBag className="f-2"/>,
                            extraClass: "border-white!"
                        }}/>
                        <AppButton data={{
                            action: "link",
                            link: appContactPageURL,
                            extraClass: "bg-white! text-black! border-white!",
                            name: AppStatic.mainSubscribe.ro.translation,
                            icon: <FaPencilAlt className="f-2"/>
                        }}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppAmbassador;
